import reducer from "./reducers";

export { default as quantitySelectors } from "./selectors";
export { default as quantityActions } from "./actions";
export { default as quantityTypes } from "./types";

export default reducer;



// WEBPACK FOOTER //
// ./dev/ducks/quantity/index.js